import { createContext } from 'react'

const defaultValue = {
  authenticated: false,
  currentSession: {}
}

export const StaffRootContext = createContext(defaultValue)

